import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=028384b7"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports